"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconArrowDownCircleOutline = _interopRequireDefault(require("./IconArrowDownCircleOutline"));
var IconArrowUpCircleOutline = /*#__PURE__*/(0, _styledComponents.default)(_IconArrowDownCircleOutline.default).withConfig({
  displayName: "IconArrowUpCircleOutline",
  componentId: "c11n-8-107-0__sc-ia4k1h-0"
})(["transform:rotate(180deg);"]);
var _default = IconArrowUpCircleOutline;
exports.default = _default;